import React, { useEffect, useState,useRef } from "react";
import "./style.scss";
import useApiPost from "../../Hooks/usePost";
import { useNavigate } from "react-router-dom";
import Storelist from "../../Store/Actions";
import { Logo } from "../../appconfig";
import { toast } from "react-toastify";
import { setLoader } from "../../Store/Actions/page";
import { BASE_URL_API, BASE_URL_API2 } from "../../appconfig";
import { FaEye,FaEyeSlash  } from "react-icons/fa";
// import {setAnalyticsUserName} from "../../Utils/helper.js"



const Login = () => {
  const { setLoading } = Storelist();
  const LoginApi = useApiPost();
  const Navigate = useNavigate();
  const [isPassword,setIsPassword] = useState("true")
  const [email,setEmail] = useState("")
  const FormSubmitHandler = (e) => {
    //console.log'hhhhhhhhh')
    e.preventDefault();
    let data = new FormData(e.target);
    setLoading(true);
    setEmail(data.get("email"))
    LoginApi.Postdata(
      `${BASE_URL_API()}validateLoginCredentials`,
      false,
      {
        emailId: data.get("email"),
        password: data.get("password"),
        role:"manager",
        deviceId: "",
      }
    );
  };

  useEffect(() => {
  
    if (LoginApi.data !== null) {
      if (LoginApi.data?.status === 200) {
        if (
          LoginApi?.data?.body?.Response?.data?.responseData?.accessToken &&
          LoginApi?.data?.body?.Response?.data?.responseData?.refreshToken
        ) {
          localStorage.setItem(
            "ACCESS",
            LoginApi?.data?.body?.Response?.data?.responseData?.accessToken
          );
          localStorage.setItem(
            "REFRESH",
            LoginApi?.data?.body?.Response?.data?.responseData?.refreshToken
          );
          localStorage.setItem("BrId",LoginApi?.data?.body?.Response?.data?.branch)
          const loginData = LoginApi?.data?.body?.Response?.data;
          const rawCity =
            loginData?.city ||
            loginData?.cityId ||
            loginData?.city_id ||
            loginData?.responseData?.city ||
            loginData?.responseData?.cityId ||
            loginData?.responseData?.city_id;
          const cityId =
            typeof rawCity === "object" && rawCity !== null
              ? rawCity?._id || rawCity?.id
              : rawCity;
          if (cityId) {
            localStorage.setItem("cityId", cityId);
            localStorage.setItem("city", cityId);
          }
          // localStorage.getItem("isLocal") == 1 ? localStorage.setItem("isLocal", 2) : localStorage.setItem("isLocal", 1);
          Navigate("/");
          console.log("setting username",email);
          // setAnalyticsUserName(email);
        } else {
          toast.warning("Login failed", {
            position: "top-center",
          });
          toast.clearWaitingQueue();
        }
      }
      setLoading(false);
    }
    else if (LoginApi.error !== null) {
      toast.warning(LoginApi.error?.body?.Response?.data?.message || "Login failed", {
        position: "top-center",
      });
      toast.clearWaitingQueue();
      setLoading(false);
    }
  }, [LoginApi.data,LoginApi.error]);
  

  useEffect(()=>{
    if(localStorage.getItem("ACCESS")){
      Navigate("/");
    }
  },[])


  const [clickCount, setClickCount] = useState(0);
  const timerRef = useRef(null);

  const handleLogoClick = () => {
    // Clear previous timer
    if (timerRef.current) clearTimeout(timerRef.current);

    // Increment click count
    const newCount = clickCount + 1;
    setClickCount(newCount);

    // Set a timeout to reset click count after 2 seconds of inactivity
    timerRef.current = setTimeout(() => {
      setClickCount(0);
    }, 2000); // 2 seconds

    // Trigger easter egg if 10 clicks happen in short span
    if (newCount >= 10) {
      const isLocal = localStorage.getItem("isLocal");
      if(isLocal == 1){
        localStorage.setItem("isLocal", 2);
        alert("you are in UAT Mode now")
      }
      else if(isLocal == 2){
        localStorage.setItem("isLocal", 2);
        alert("you are in PROD Mode now")
      }
      else{
        localStorage.setItem("isLocal", 2);
        alert("you are in DEV Mode now")
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-input-wrapper">
        <div className="login-header">
          <img src={Logo} alt="Logo"  onClick={handleLogoClick}/>
          <button className="invisible">
            <i className="fa-solid fa-location-dot"></i>
            <span>Velachery</span>
          </button>
        </div>

        <form action="" onSubmit={FormSubmitHandler} className="relative">
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Email"
            required
          />
          <input
            type={isPassword?"password":"text"}
            name="password"
            id="password"
            placeholder="Password"
            required
            minLength={8}
          />
          <span className="absolute bottom-17 right-3">{isPassword?<FaEyeSlash onClick={()=>{setIsPassword(!isPassword)}}/>:<FaEye onClick={()=>{setIsPassword(!isPassword)}}/>}</span>

          <div className="btn-container justify-between">
            <button type="button" onClick={()=>{Navigate("/forgotpassword")}}>Forgot Password?</button>
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
